'use client'

import PlusIcon from '@/components/icons/PlusIcon'
import Card from '@/components/ui/Card'
import ImageWithFallback from '@/components/ui/ImageWithFallback'
import ContentWrapper from '@/components/ui/ContentWrapper'
import { getFeaturedProjectRecords } from '@/content/projects'
import PortfolioSliceCarousel from '@/modules/home/portfolio-slice/components/PortfolioSliceCarousel'
import { IMAGES_BACKEND_URL } from '@/utils/constants'
import { ProjectWithTranslations } from '@/utils/types/ProjectWithTranslations'
import { useLocale } from 'next-intl'
import Link from 'next/link'
import { useMemo } from 'react'

const PortfolioSlice = () => {
  const locale = useLocale()

  // Inhalte liegen seit der PocketBase-Ablösung statisch im Bundle, kein Fetch mehr nötig
  const projects = useMemo(() => {
    const items = getFeaturedProjectRecords() as unknown as ProjectWithTranslations[]
    return items.map((project) => ({
      ...project,
      project_description: locale === 'en' && project.project_description_en ? project.project_description_en : project.project_description,
      services_text: locale === 'en' && project.services_text_en ? project.services_text_en : project.services_text,
      focus_text: locale === 'en' && project.focus_text_en ? project.focus_text_en : project.focus_text,
      details_text: locale === 'en' && project.details_text_en ? project.details_text_en : project.details_text
    }))
  }, [locale])

  if (!projects || projects.length === 0) {
    return null
  }
  return (
    <>
      <ContentWrapper tag="article" className="!hidden lg:grid! mt-32 grid-cols-12 gap-8">
        {projects.map((project) => (
          <Link href={`${locale === 'en' ? '/en/projects' : '/projekte'}/${project.slug}`} key={project.id} className="flex flex-col col-span-3">
            <Card className="p-0! min-h-96 overflow-hidden rounded-2xl grow relative">
              <ImageWithFallback
                fill
                sizes="90vw"
                className="w-full h-full object-cover"
                src={IMAGES_BACKEND_URL + 'projects/' + project.id + '/' + project.main_image}
                fallbackSrc="/images/mocks/mock-bg.jpg"
                alt={project.name + '`s image'}
              />
            </Card>
            <div className="mt-8">
              <PlusIcon size={20} color={'#fff'} className="w-5 h-5 object-cover" />
              <p className="mt-8 text-white leading-6 text-lg font-light">
                <strong className="font-medium">{project.name}</strong>
              </p>
            </div>
          </Link>
        ))}
      </ContentWrapper>
      <div className="block lg:hidden -mx-8 mt-32">
        <PortfolioSliceCarousel data={projects} options={{ loop: true, align: 'center' }} />
      </div>
    </>
  )
}

export default PortfolioSlice
